export const aboutContent = {
    en: {
        title: "About Revimo Online",
        description: `Revolutionizing physiotherapy with accessible, 
        professional care delivered right to your home.`,
        subTitle1: "Our Mission",
        description1: `At Revimo, we believe everyone deserves access to
                quality physiotherapy care. Our mission is to break down
                geographical and financial barriers. To make expert treatment accessible to
                all, regardless of location or economic background.`,
        subTitle2: "What We Offer",
        description2: `We provide detailed physiotherapy sessions designed by our physiotherapists. We also allow physiotherapists to create their own personalized plans and upload them on Revimo for their clients.`,
        yExperience: "Years Experience",
        availability: "Availability",
        cpSubTitle: "Ceritfied Professionals",
        cpText: `All physiotherapists are licensed, experienced professionals
                with verified credentials and continuous training.`,
        secPlatformTitle: "Secure Platform",
        secPlatformText: `Your privacy matters. We use industry-leading security to
                protect your health information.`,


    },
    sl:{
        title: "O storitvi Revimo Online",
        description: `Sodobna fizioterapija na daljavo – strokovna pomoč,
        ki jo prejmete v udobju svojega doma.`,
        subTitle1: "Naše poslanstvo",
        description1: `V Revimo verjamemo, da bi vask moral imeti možnost
                dostopa do kakovostne fizioterapije. Naše poslanstvo je,
                da odstranimo geografske ovire in omogočimo strokovno obravnavo
                vsem, ne glede na to, kje živijo.`,
        subTitle2: "Kaj vam nudimo",
        description2: `Nudimo celovite spletne fizioterapevtske storitve:
                rehabilitacijo po poškodbah, obravnavo kronične bolečine,
                vodenje okrevanja po operacijah ter preventivno obravnavo.
                Naša platforma združuje napredne tehnologije z osebnim pristopom
                in skrbjo za posameznika.`,
        yExperience: "Let izkušenj",
        availability: "Termin je na voljo",
        cpSubTitle: "Strokovna fizioterapevtska ekipa",
        cpText: `Naše fizioterapevte odlikujejo strokovna usposobljenost,
                dolgoletne izkušnje in stalno dodatno izobraževanje.`,
        secPlatformTitle: "Varna spletna platforma",
        secPlatformText: `Varovanje vaših podatkov jemljemo resno. Uporabljamo
                visoke varnostne standarde za zaščito vaše zdravstvene dokumentacije.`}
} as const;